<template>
  <div>
    <volcan-input-text
      v-model="item.sortOrder"
      :text="$t('sortorder.labels.sortOrder')"
      type="number"
    />
    <div
      class="col-12 alert alert-info"
      style="font-size: smaller"
      v-html="$t('sortorder.labels.sortOrderInfo')"
    ></div>
  </div>
</template>
<script>
import en from "./sortorder-en.json";
import fr from "./sortorder-fr.json";
export default {
  name: "volcan-sortorder",
  beforeMount() {
    this.$i18n.add("fr", fr);
    this.$i18n.add("en", en);
  },
  data: function () {
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  model: {
    prop: "item",
    event: "modified",
  },
  computed: {
    itemLocal: {
      get() {},
      set(newValue) {
        this.$emit("modified", newVal);
      },
    },
  },
  methods: {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Custom/SortOrder/SortOrder.vue